export default __webpack_public_path__ + "static/media/contacts_symbol_200x200.09d23ba8.png";